import Modal from 'bootstrap/js/dist/modal';

/**
 * External link intermediary site modal
 */
const interstitialModal = () => {
  // use wp-18n
  const { __, _x, _n, _nx } = wp.i18n; // eslint-disable-line no-unused-vars,no-undef

  const externalLinkInterstitial = document.getElementById(
    'externalLinkInterstitial',
  );

  if (externalLinkInterstitial) {
    const externalLinks = document.querySelectorAll(
      '#page a[href].external-link:not(.safe-url)',
    );
    const externalLinkBehavior =
      externalLinkInterstitial.dataset.miraExternalLinkBehavior;
    const redirectMessageElem = document.getElementById(
      'externalLinkInterstitialStatusMessage',
    );
    const spinner = externalLinkInterstitial.querySelector('.spinner-border');

    const modal = new Modal(externalLinkInterstitial); // eslint-disable-line no-undef
    const modalType = externalLinkInterstitial.dataset.miraType;

    // configure modal init. options
    modal._config.backdrop = modalType !== 'notify' ? 'static' : true;
    modal._config.keyboard = modalType !== 'notify' ? false : true;

    externalLinks.forEach((link) => {

      link.addEventListener('click', function(event) {
        // prevent default
        event.preventDefault();

        const url = this.getAttribute('href');
        const target = this.getAttribute('target');

        externalLinkInterstitial.setAttribute('data-target', target);
        externalLinkInterstitial.setAttribute('data-url', url);

        // show intermediary modal
        modal.show();

        // if non-blocking
        if (modalType === 'notify') {
          const secondsElem = document.getElementById(
            'externalLinkInterstitialTimeRemaining',
          );
          const redirectTime =
            externalLinkInterstitial.dataset.miraRedirectTime;
          let timerIndex = redirectTime;

          // set initial message
          redirectMessageElem.innerHTML = __('Redirecting in ', 'mira');

          const timer = setInterval(() => {
            if (timerIndex-- <= 1) {
              // reset timer
              clearInterval(timer);

              // display loader
              showLoader();

              // hide countdown timer
              secondsElem.style.display = 'none';

              // update redirectMessage
              if (externalLinkBehavior === '_blank') {
                redirectMessageElem.innerHTML = __(
                  'Opening link in a new browser tab/window...',
                  'mira',
                );
              } else {
                redirectMessageElem.innerHTML = __(
                  'Redirecting now...',
                  'mira',
                );
              }

              // redirect user
              clickExternalLink(externalLinkInterstitial.getAttribute('data-url'), target, 1000);

              if (externalLinkBehavior === '_blank') {
                setTimeout(() => {
                  // hide loader
                  hideLoader();

                  // update redirectMessage
                  redirectMessageElem.innerHTML = __(
                    'You may now close this notification.',
                    'mira',
                  );
                }, 2000);
              }
            } else {
              // update redirectMessage
              outputTimeRemainingText(secondsElem, timerIndex);
            }
          }, 1000);

          // immediately stop & reset timer if modal starts to close
          externalLinkInterstitial.addEventListener('hide.bs.modal', () => {
            clearInterval(timer);
          });

          // reset various modal items after fully closed
          externalLinkInterstitial.addEventListener('hidden.bs.modal', () => {
            timerIndex = redirectTime;
            // hideLoader();
            outputTimeRemainingText(secondsElem, timerIndex);
            secondsElem.style.display = 'inline';
            redirectMessageElem.innerHTML = __('Redirecting in ', 'mira');
          });

          const outputTimeRemainingText = (el, secondsRemaining) => {
            el.innerHTML =
              secondsRemaining +
              ' ' +
              _n('second', 'seconds', secondsRemaining, 'mira') +
              '...';
          };
        }

        // if blocking
        else if (modalType === 'force-acceptance') {
          const proceedButton = document.getElementById(
            'externalLinkInterstitialProceedButton',
          );
          const cancelButton = document.getElementById(
            'externalLinkInterstitialCancelButton',
          );

          if (proceedButton.getAttribute('data-init') !== 'yes') {
            proceedButton.setAttribute('data-init', 'yes');

            proceedButton.addEventListener('click', () => {
              // display loader
              showLoader();

              let ancestor = proceedButton.closest('.modal');
              let target = ancestor.getAttribute('data-target');
              let url = ancestor.getAttribute('data-url');

              // redirect user
              clickExternalLink(url, target);

              if (externalLinkBehavior === '_blank') {
                // add message
                redirectMessageElem.innerHTML = __(
                  'You may close this window.',
                  'mira',
                );

                // hide buttons & loader
                proceedButton.classList.add('d-none');
                cancelButton.classList.add('d-none');
                hideLoader();

                // set modal to be non-static & re-enable keyboard
                modal._config.backdrop = true;
                modal._config.keyboard = true;
              }
            });
          }

          // reset various modal items after fully closed
          externalLinkInterstitial.addEventListener('hidden.bs.modal', () => {
            // set modal to be non-static & re-enable keyboard
            modal._config.backdrop = 'static';
            modal._config.keyboard = false;

            // show buttons
            proceedButton.classList.remove('d-none');
            cancelButton.classList.remove('d-none');

            // reset messaging
            redirectMessageElem.innerHTML = '';
          });
        }
      });
    });

    const showLoader = () => {
      spinner.classList.remove('d-none');
    };

    const hideLoader = () => {
      spinner.classList.add('d-none');
    };

    // const showButtons = (proceedButton, cancelButton) => {
    //   if ( modalType === 'force-acceptance' ) {
    //     // document.getElementById('externalLinkInterstitialProceedButton').classList.remove('d-none');
    //     proceedButton.classList.remove('d-none');
    //     // document.getElementById('externalLinkInterstitialCancelButton').classList.remove('d-none');
    //     cancelButton.classList.remove('d-none');
    //   }
    // }

    // const hideButtons = (proceedButton, cancelButton) => {
    //   if ( modalType === 'force-acceptance' ) {
    //     // document.getElementById('externalLinkInterstitialProceedButton').classList.add('d-none');
    //     proceedButton.classList.add('d-none');
    //     // document.getElementById('externalLinkInterstitialCancelButton').classList.add('d-none');
    //     cancelButton.classList.add('d-none');
    //   }
    // }

    const clickExternalLink = (url, target = null, delay = 0) => {
      // window.location.assign(url);

      // create new anchor tag
      const a = document.createElement('a');

      // set appropriate attributes
      // a.setAttribute('rel', 'noopener noreferrer');
      // a.setAttribute('target', externalLinkInterstitial.dataset.miraExternalLinkBehavior);
      // if ( externalLinkBehavior !== 'none' ) {
      // if ( externalLinkBehavior === '_blank' ) {
      if (target === '_blank') {
        a.setAttribute('target', target);
      }

      // set href
      a.href = url;

      // simulate 'click'
      setTimeout(() => {
        a.click();
      }, delay);
    };
  }
};

export default interstitialModal;
